"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteBlocksList = void 0;
var QuoteBlocksList_1 = require("@CommonFrontend/QuoteV2/QuoteBlocksList");
var Sentry = __importStar(require("@sentry/browser"));
var lodash_1 = __importDefault(require("lodash"));
var QuoteBlocksList = (function (_super) {
    __extends(QuoteBlocksList, _super);
    function QuoteBlocksList() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.quoteBlocks = [];
        _this.quoteAdapters = [];
        _this.get = function () {
            return _this.quoteBlocks;
        };
        _this.getAdapters = function () {
            return _this.quoteAdapters;
        };
        _this.add = function (block) {
            var existingBlock = _this.quoteBlocks.find(function (qb) { return qb.blockId === block.blockId; });
            if (existingBlock) {
                Sentry.captureException(new Error("INVARIANT 86cvktdq3: QuoteBlocksList received a block that is already registered"), {
                    extra: {
                        blockId: block.blockId,
                        isSameObjectRef: block === existingBlock,
                    },
                });
            }
            _this.quoteBlocks.push(block);
        };
        _this.remove = function (block) {
            lodash_1.default.remove(_this.quoteBlocks, function (q) { return q === block; });
        };
        _this.addAdapter = function (quoteAdapter) {
            _this.quoteAdapters.push(quoteAdapter);
        };
        _this.removeAdapter = function (quoteAdapter) {
            lodash_1.default.remove(_this.quoteAdapters, function (a) { return a === quoteAdapter; });
        };
        _this.getWithBlockIds = function () {
            return _this.get().map(function (block) { return ({ id: block.blockId, quoteBlock: block }); });
        };
        return _this;
    }
    return QuoteBlocksList;
}(QuoteBlocksList_1.QuoteBlocksList));
exports.QuoteBlocksList = QuoteBlocksList;
